import React from 'react';
import { hqTab, retailTab } from './constants';

type Props = {
  onClick: (tab: string) => void;
  activeTab: string;
};

export const DepartmentTabs = ({ onClick, activeTab }: Props) => {
  return (
    <div className="department-tabs">
      {[hqTab, retailTab].map((tab) => (
        <button className={`h6 uppercase ${activeTab === tab && 'active'}`} onClick={() => onClick(tab)}>
          {tab}
        </button>
      ))}
    </div>
  );
};
